//detect if webP is allowed image format
//if we know it does too late, "tant pis" we will take the gif url
let 
  urlKey = "url",
  checkWebP = new Image();
checkWebP.onload = function(){
  urlKey = "webp"
}
checkWebP.src = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';

class Gif{
  constructor(json){
    this.image = new GifImage(json.images.fixed_width_downsampled)
    try{
      this.url = json.images.fixed_height.url;
    }catch(e){
      //WARN this one does not work via webog
      this.url = json.url;
    }
  }
}
class GifImage{
  constructor(json){
    this.url = json[urlKey];
    this.width = parseInt(json.width)
    this.height = parseInt(json.height)
  }
}

function decodeArrayOfGif(json){
  var result = []
  json.forEach(g=>{
    result.push(new Gif(g))
  })
  return result;
}

function search(q,api_key,lang="FR",limit=20,offset=0){
  let url = `//api.giphy.com/v1/gifs/search?q=${encodeURIComponent(q)}&api_key=${api_key}&lang=${lang}&limit=${limit}&offset=${offset}&rating=g`;

  //FIXME use this instead but review tha paginattions stuff
  
  return fetch(url).then(response=>{
      return response.json();
    }).then(json=>{
      return {
        data:decodeArrayOfGif(json.data)
        //next : code this!!     
      }
    })
    
} 
function searchCallback(callback,onerror,q,api_key,lang="FR",limit=12,offset=0){
  let url;
  if(q){
    url = `//api.giphy.com/v1/gifs/search?q=${encodeURIComponent(q)}&api_key=${api_key}&lang=${lang}&limit=${limit}&offset=${offset}&rating=g`;
  }else{
    url = `//api.giphy.com/v1/gifs/trending?api_key=${api_key}&limit=${limit}&offset=${offset}&rating=g`;
  }
  fetch(url)
  .then(response=>{
    return response.json();
  })
  .then(json=>{
    let decoded = decodeArrayOfGif(json.data);
    
    callback({
      data:decoded,
      next:decoded.length===0?function(){}:function(callback,onerror){
        searchCallback(callback,onerror,q,api_key,lang,limit,offset+limit)
      }
    });
  })
  .catch(onerror)
}


export {search,searchCallback}